import { FEEDBACKS_ACTIONS } from './FEEDBACKS_ACTIONS'

export function feedbacksReducer(state, action) {
  switch (action.type) {
    case FEEDBACKS_ACTIONS.SET_FEEDBACKS:
      return {
        ...state,
        questions: action.payload.questions,
      }
    case FEEDBACKS_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}
